import Tool, {
  type ToolArgs,
  type ToolArgsWithController,
} from '../../../tools/Tool';
import { Range } from 'slate';
import { type LabelPillElement } from '../../../types/aha-editor';
import {
  isInlineActive,
  unwrapInline,
  wrapInline,
} from '../../InlinePlugin/utils';

// Insert a pill into the editor.
class ToolInsertLabelPill extends Tool {
  static toolName = 'Label';
  static iconClass = 'fa-regular fa-square-info';

  static available({ controller }: ToolArgsWithController): boolean {
    return Boolean(controller.ahaEditor.hasPlugin('labelPillSchema'));
  }

  static action({ editor, element }: ToolArgs): void {
    if (!editor?.selection) return;

    const { selection } = editor;

    if (isInlineActive(editor, 'pill')) {
      unwrapInline(editor, 'pill');
      return;
    }

    const buildElement = (): LabelPillElement => ({
      type: 'pill',
      pill_colorScheme: 'gray',
      children: Range.isCollapsed(selection) ? [{ text: '' }] : [],
    });

    wrapInline(editor, buildElement);
  }

  static isActive({ editor }: ToolArgs) {
    return isInlineActive(editor, 'pill');
  }
}

export default ToolInsertLabelPill;
